export const community = "community.intelligems.io";

export const generalSupportForm =
  "https://portal.usepylon.com/intelligems/forms/intelligems-support-request";

export const pylonChangePlanRequest =
  "portal.usepylon.com/intelligems/forms/plan-change-request";

export const upsellRuleBuilderRequestForm =
  "https://portal.usepylon.com/intelligems/forms/upsell-rule-builder";

export const ruleBuilderFeedbackForm =
  "https://intelligems.portal.usepylon.com/forms/rule-builder-feedback";

export const postPurchaseFunnelRequestForm =
  "https://intelligems.portal.usepylon.com/forms/post-purchase-funnel-interest-form";

// Hubspot Docs
//#region -- Price Testing
export const priceTestSetup =
  "docs.intelligems.io/price-testing/how-to-set-up-a-price-test";

export const endPriceTest =
  "docs.intelligems.io/price-testing/ending-a-price-test";

export const priceShopPlusIntegration =
  "docs.intelligems.io/getting-started/pricing-integration-guides/integration-guide-for-shopify-plus";

export const priceFunctionsIntegration =
  "docs.intelligems.io/getting-started/pricing-integration-guides/integration-guide-using-shopify-functions";

export const priceNonPlusIntegration =
  "docs.intelligems.io/getting-started/pricing-integration-guides/integration-guide-for-shopify-advanced-shopify-and-shopify-basic";

export const subscriptionProductTesting =
  "docs.intelligems.io/price-testing/testing-with-subscriptions";

export const duplicateProductsGuide =
  "docs.intelligems.io/price-testing/price-testing-integration-guides/integration-guide-using-duplicate-products";

export const multiCurrencyTesting =
  "docs.intelligems.io/price-testing/multi-currency-testing";

export const priceTestIntegrationGettingStarted =
  "docs.intelligems.io/getting-started/pricing-integration-guides";

export const priceTestQaChecklist =
  "docs.intelligems.io/price-testing/price-test-qa-checklist";

export const priceTestPriceTagging =
  "docs.intelligems.io/getting-started/price-testing-integration-guides/integration-guide-using-checkout-scripts/step-2-tag-product-prices";

export const zapierWebhookExample = `docs.intelligems.io/integrations/webhook-integration#example-zapier-to-slack-integration`;

export const bundlePriceTesting =
  "docs.intelligems.io/price-testing/price-testing-faqs#can-i-price-test-shopify-bundle-products";

export const priceTestIntegrationRequest =
  "https://portal.usepylon.com/intelligems/forms/price-test-integration-request";

export const shippingTestSetupForm =
  "https://portal.usepylon.com/intelligems/forms/shipping-test-setup";

export const shippingTestProgressBarStep =
  "docs.intelligems.io/shipping-testing/how-to-set-up-a-shipping-test#step-8-enable-and-customize-your-progress-bar-if-needed";

export const queryParamTargetingLink =
  "docs.intelligems.io/general-features/targeting/page-targeting#what-about-query-parameters";

export const updatePricesWhenStartingTestLink =
  "docs.intelligems.io/pricing-experiences/price-testing-faqs#why-does-intelligems-update-my-shopify-prices-when-i-start-an-experience";

export const priceTestConflictFaqLink =
  "docs.intelligems.io/price-testing/price-testing-faqs#can-i-run-a-shipping-test-and-a-price-test-at-the-same-time";

//#endregion --
//#region -- Integrations
export const googleAnalyticsIntegration =
  "docs.intelligems.io/integrations/google-analytics-4-integration";

export const amplitudeIntegration =
  "docs.intelligems.io/integrations/amplitude-integration";

export const heapIntegration =
  "docs.intelligems.io/integrations/heap-integration";

export const segmentIntegration =
  "docs.intelligems.io/integrations/segment-integration";

export const heatmapIntegration =
  "docs.intelligems.io/integrations/heatmap-integrations/integrating-with-heatmap.com";

export const microsoftClarityIntegration =
  "docs.intelligems.io/integrations/heatmap-integrations/integrating-with-microsoft-clarity";

export const hotjarIntegration =
  "docs.intelligems.io/integrations/heatmap-integrations/integrating-with-hotjar";

export const stayAiIntegrationLink =
  "docs.intelligems.io/price-testing/testing-prices-with-subscriptions/testing-prices-with-recharge-2.0-or-stay.ai#stay.ai";

export const rechargeIntegrationLink =
  "docs.intelligems.io/price-testing/testing-prices-with-subscriptions/testing-prices-with-recharge-2.0-or-stay.ai#recharge";

//#endregion
//#region -- Shipping Testing
export const intelligemsRateShippingTest =
  "docs.intelligems.io/shipping-testing/starting-a-shipping-test";

export const shippingTestSetup =
  "docs.intelligems.io/shipping-testing/shipping-testing-getting-started";

export const endShippingTest =
  "docs.intelligems.io/shipping-testing/ending-a-shipping-test";

/** Book time with the shipping team, e.g. after a mid-test Markets migration. */
export const shippingMigrationBookACall =
  "https://calendar.app.google/kiME5uDy75GZZVTv5";

export const shippingProgressBar =
  "docs.intelligems.io/shipping-testing/shipping-progress-bar-integration";

export const shippingTestQaChecklist =
  "docs.intelligems.io/shipping-testing/shipping-test-qa-checklist";

export const thresholdShippingPreDiscount =
  "docs.intelligems.io/shipping-testing/how-to-set-up-a-shipping-test#step-6-configure-the-intelligems-rate-s";

export const shippingTestNonDefaultCurrency =
  "docs.intelligems.io/shipping-testing/shipping-testing-faqs#can-i-run-a-shipping-test-in-a-currency-other-than-my-stores-default-currency";

export const duplicateShippingTestFaqLink =
  "docs.intelligems.io/shipping-testing/shipping-testing-faqs#i-duplicated-my-shipping-test.-what-are-the-steps-i-need-to-take-to-complete-the-setup";

export const shippingMarketsMidTestFaqLink =
  "docs.intelligems.io/shipping-experiences/shipping-testing-faqs#why-will-switching-mid-test-break-my-test";

export const shippingTestConflictFaqLink =
  "docs.intelligems.io/shipping-testing/shipping-testing-faqs#can-i-run-a-shipping-test-and-a-price-test-at-the-same-time";

//#endregion --
//#region -- General Testing
export const allIntegrationGuides =
  "docs.intelligems.io/getting-started/adding-intelligems-script-to-your-theme";

export const appEmbedIntegrationGuide =
  "docs.intelligems.io/getting-started/adding-intelligems-script-to-your-theme#option-2-use-the-app-embed-block";

export const commonUseCases =
  "docs.intelligems.io/getting-started/common-use-cases";

export const bestPracticesDuringTest =
  "docs.intelligems.io/getting-started/best-practices/best-practices-during-a-test";

export const audienceTargeting =
  "docs.intelligems.io/content-testing/targeting/audience-targeting";

export const cookieTargeting =
  "docs.intelligems.io/content-testing/targeting/audience-targeting#custom-audiences";

export const offerTestGettingStarted =
  "docs.intelligems.io/offer-personalizations/testing-offer-personalizations";

//#endregion --
//#region -- Offers --
export const integratingComponents =
  "docs.intelligems.io/personalizations/personalization-modifications/offers-integrating-widgets";

export const quantityButtonSetup =
  "docs.intelligems.io/personalizations/personalization-modifications/offers-integrating-widgets?utm_source=intelligems_app#quantity-buttons";

export const offerProgressBarSetup =
  "docs.intelligems.io/personalizations/personalization-modifications/offers-integrating-widgets?utm_source=intelligems_app#offer-progress-bar";

export const shippingProgressBarSetup =
  "docs.intelligems.io/personalizations/personalization-modifications/offers-integrating-widgets?utm_source=intelligems_app#shipping-progress-bar";

export const cartGwpPickerSetup =
  "docs.intelligems.io/offer-personalizations/offers-integrating-widgets/cart-gwp-picker";

//#endregion ---
//#region -- Content Testing --
export const pageRedirects =
  "docs.intelligems.io/content-testing/content-testing-getting-started/how-to-set-up-a-split-url-test#step-3-set-up-redirects";

export const templateRedirectsLink =
  "docs.intelligems.io/content-testing/how-to-set-up-a-content-test/how-to-set-up-a-template-test";

export const themeRedirect =
  "docs.intelligems.io/content-testing/how-to-set-up-a-content-test/how-to-set-up-a-theme-test";

export const addTemplateSnippet =
  "docs.intelligems.io/developer-resources/intelligems-theme-snippets#template-testing-snippet";

export const contentTestQaChecklist =
  "docs.intelligems.io/content-testing/content-test-qa-checklist";

export const endingThemeTest =
  "docs.intelligems.io/content-testing/ending-a-theme-test";

export const endingThemePersonalization =
  "docs.intelligems.io/personalizations/theme-personalization-precautions#ending-personalizations-involving-a-theme-change";

export const standardPageTargeting =
  "docs.intelligems.io/content-testing/targeting/page-targeting";

export const postPurchaseThemeTest =
  "docs.intelligems.io/getting-started/adding-intelligems-script-to-your-theme#post-purchase-page-for-theme-tests";

export const splitUrlTestFaq =
  "docs.intelligems.io/content-testing/content-testing-faqs#why-must-visitors-visit-the-origin-url-to-be-included-in-the-test";

export const templateTestFaq =
  "docs.intelligems.io/content-testing/content-testing-faqs#why-must-visitors-visit-a-page-assigned-to-the-control-groups-template-in-shopify-to-be-included-in";

export const productCardTargetingSetup =
  "docs.intelligems.io/general-features/targeting/product-targeting/how-to-set-up-collection-card-product-targeting";

export const productTargetingGuide =
  "docs.intelligems.io/general-features/targeting/product-targeting";

//#endregion
//#region -- Analytics
export const dataExport = "docs.intelligems.io/analytics/exporting-data";

export const profitAnalysis =
  "docs.intelligems.io/analytics/how-to-add-profit-to-intelligems-analytics";

export const statSigPage =
  "docs.intelligems.io/analytics/statistical-significance";

export const customEventsLink =
  "docs.intelligems.io/analytics/custom-events/overview";

export const customJavascriptEventLink =
  "docs.intelligems.io/analytics/custom-events/custom-javascript-events";

export const customEventsPageScopingLink =
  "docs.intelligems.io/analytics/custom-events/scoping-to-specific-pages";

export const newVsReturningCustomersFaq =
  "docs.intelligems.io/analytics/analytics-faqs#how-does-intelligems-determine-new-vs-returning-visitors";

export const resetToPendingFaq =
  "docs.intelligems.io/analytics/analytics-faqs#how-does-resetting-my-test-to-pending-work";

export const postTestMetricsLink =
  "docs.intelligems.io/analytics/experiment-analytics/metric-definitions/post-test-metrics";

//#endregion --
//#region -- Hubspot Category Links
export const introductionToIntelligems = "docs.intelligems.io";
export const priceIntegrationDocs = "docs.intelligems.io/price-testing";
export const shippingTesting = "docs.intelligems.io/shipping-testing";
export const contentTesting = "docs.intelligems.io/content-testing";
export const analyzingResults = "docs.intelligems.io/analytics/overview";

export const bookSmartPricingConsultation =
  "meetings.hubspot.com/jennifer1280/book-consultation-smart-pricing";

//#endregion
//#region -- Targeting
export const marketCurrencyTarget =
  "docs.intelligems.io/content-testing/targeting";

export const targeting = "docs.intelligems.io/content-testing/targeting";

export const targetingFaqLink =
  "docs.intelligems.io/general-features/targeting/targeting-faqs";

export const purchaseLikelihoodTargeting =
  "docs.intelligems.io/general-features/targeting/audience-targeting/purchase-likelihood-targeting";

//#endregion
export const pricingPage = "intelligems.io/pricing";

//#region -- Shopify
export const appListing =
  "apps.shopify.com/intelligems?utm_source=login&utm_medium=app";

export const thirdPartyCarrierCalculatedShipping =
  "help.shopify.com/en/manual/fulfillment/setup/shipping-rates/third-party-carrier-calculated-shipping";

//#endregion
//#region -- Performance
export const igDirectScriptAdd =
  "docs.intelligems.io/getting-started/integration-guides/adding-intelligems-script-to-your-theme#option-1-add-to-your-theme-code";

//#endregion
//#region -- Personalizations
export const personalizationsGettingStarted =
  "docs.intelligems.io/personalizations/personalizations-getting-started";

export const targetingPersonalizations =
  "docs.intelligems.io/personalizations/targeting-personalizations#audience-targeting";

export const personalizationUrlRedirects =
  "docs.intelligems.io/personalizations/personalization-modifications#url-redirects";

export const personalizationThemeRedirects =
  "docs.intelligems.io/personalizations/personalization-modifications#theme-changes";

export const personalizationTemplateRedirects =
  "docs.intelligems.io/content-testing/content-testing-getting-started/how-to-set-up-a-template-test#step-3-assign-a-template-for-each-test-group";

export const personalizationContentEdits =
  "docs.intelligems.io/personalizations/personalization-modifications#content-edits";

export const personalizationOnsiteInjections =
  "docs.intelligems.io/personalizations/personalization-modifications#styles-and-javascript";

export const personalizationUnsavedChangesPreview =
  "docs.intelligems.io/personalizations/previewing-personalizations#step-1-save-your-changes";

export const personalizationPriceModGetStarted =
  "docs.intelligems.io/personalizations/personalization-modifications#price-changes";

export const personalizationOffersPromotions =
  "docs.intelligems.io/personalizations/personalization-modifications/offer-modifications#promotions";

export const personalizationOffersGwp =
  "docs.intelligems.io/personalizations/personalization-modifications/offer-modifications#gift-with-purchase";

export const personalizationOffersVolumeDiscount =
  "docs.intelligems.io/personalizations/personalization-modifications/offer-modifications#volume-discounts";

export const personalizationOffersShipping =
  "docs.intelligems.io/personalizations/personalization-modifications/offer-modifications#free-shipping-offer";

export const personalizationRollingOutTests =
  "docs.intelligems.io/personalizations/rolling-out-tests";

export const personalizationPageTargeting =
  "docs.intelligems.io/personalizations/targeting-personalizations#page-targeting";

export const personalizationsOfferTesting =
  "docs.intelligems.io/personalizations/testing-offer-personalizations";

export const personalizationsDiscountSyncError =
  "docs.intelligems.io/personalizations/personalizations-faqs#what-does-discount-synchronization-error-mean-and-how-do-i-fix-it";

export const personalizationAudienceEvaluation =
  "docs.intelligems.io/personalizations/targeting-modes-for-personalizations";

export const personalizationOfferQaChecklist =
  "docs.intelligems.io/personalizations/offer-test-qa-checklist";

//#endregion
export const offerTestQaChecklistLink =
  "docs.intelligems.io/offer-personalizations/offer-test-qa-checklist";

export const checkoutTestIntegrationLink =
  "docs.intelligems.io/checkout/how-to-set-up-a-checkout-personalization-or-test#step-5-add-the-block-to-shopify-checkout";

export const gettingStartedCheckoutBlocksLink =
  "docs.intelligems.io/checkout/getting-started-with-checkout";

export const checkoutBlockTestQA =
  "docs.intelligems.io/personalizations/checkout-test-qa-checklist";

export const postPurchaseProviderSetup =
  "docs.intelligems.io/post-purchase-upsells/how-to-set-up-a-post-purchase-upsell-personalization-or-test#step-5-enable-intelligems-in-shopify";

export const postPurchaseUpsellQaChecklist =
  "docs.intelligems.io/post-purchase-upsells/post-purchase-upsell-qa-checklist";

export const startWithOfferTestingBlogLink =
  "https://www.intelligems.io/resources/blog/you-should-always-start-with-offer-testing";

export const productGroupsLink =
  "docs.intelligems.io/analytics/how-to-add-product-groups-to-intelligems-analytics";

export const headlessBookDemoLink =
  "https://www.intelligems.io/book-a-demo-in-app";

export const plusOnboardingBookDemoLink =
  "https://www.intelligems.io/book-a-demo";

export const salesNudgeBookDemoLink = "https://www.intelligems.io/book-a-demo";

// Temporary destination for the Smart Pricing gate "View demo" CTA — swap to
// the demo video once marketing produces one.
export const smartPricingDemoLink = "https://www.intelligems.io/book-a-demo";

export const invalidDomainHelpLink =
  "https://docs.intelligems.io/getting-started/general-faqs#can-i-test-across-domains-or-stores";

export const msa = "www.intelligems.io/msa";

// #region -- Headless
export const headlessInstallOverview = "headless.intelligems.io/";
export const headlessGeneralSteps = "headless.intelligems.io/general-steps";

export const headlessInstallRequirements =
  "headless.intelligems.io/next.js-steps/requirements";

//#endregion

// #region -- Loom Videos
export const offersIntroVideoUrl =
  "https://www.loom.com/embed/3b923d1a99e041e6807b6ce71f0b7dc7?sid=84c40e9b-4629-4faf-a3e7-2b6f14803c41";

export const siteContentDemoVideoUrl =
  "https://www.loom.com/embed/25fac7cb5cf94d5a8187731487e543ac?sid=9e6c9531-3939-4f7b-8be3-f89a6576e807";

//#endregion

export const intelligemsAcademySkool =
  "https://www.skool.com/intelligems-academy-1535/about?ref=77c97b6259854f67a5f381a303bc7fd4";

export const externalApiLink =
  "docs.intelligems.io/developer-resources/external-api";

export const mcpServerLink =
  "https://docs.intelligems.io/developer-resources/mcp-server";

export const mcpGptLink =
  "https://docs.intelligems.io/developer-resources/mcp-server/chatgpt";

export const mcpClaudeLink =
  "https://docs.intelligems.io/developer-resources/mcp-server/claude";

export const mcpGeminiLink =
  "https://docs.intelligems.io/developer-resources/mcp-server/google-gemini";

export const postPurchaseFunnelInterestForm =
  "https://portal.usepylon.com/intelligems/forms/post-purchase-funnel-interest-form";

export const newCheckoutBlockRequestType =
  "https://portal.usepylon.com/intelligems/forms/checkout-request";

export const likelihoodToPurchaseInterestForm =
  "https://portal.usepylon.com/intelligems/forms/likelihood-to-purchase-interest";
